import React from 'react';
import c from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import {
  BiData,
  ClickShareBiEvent,
  BiContextProvidedValue,
} from '@wix/da-bi/pkg/events';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ThemeOptions } from '@wix/da-react-context/pkg/constants';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { DesktopSharePopup } from '@wix/da-shared-react/pkg/SharePopup';
import { setRef } from '@wix/da-shared-react/pkg/utils/refHelpers';
import IconButtonWithPopover from '@wix/da-shared-react/pkg/Dropdown/Preset/IconButtonWithPopover';
import s from '../../SubNavBarDesktop.scss';

interface Props {
  profileOwner: PapiUser;
}

const ShareButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ profileOwner }, ref) => {
    const { t } = useTranslation();
    return (
      <IconButtonWithPopover
        innerRef={node => setRef(ref, node)}
        biData={BiData<ClickShareBiEvent>({
          evid: 355,
          typeid: BiContextProvidedValue,
          itemid: BiContextProvidedValue,
        })}
        className={c(s['icon'], s['icon_hover'])}
        tooltipText={t('navigation.subnavigation.share')}
        popoverOffset={[0, 8]}
        placement="bottom-end"
        popoverChildren={
          <ThemeOverride theme={ThemeOptions.LIGHT}>
            <DesktopSharePopup
              url={Url.userLink(profileOwner.username)}
              title={t('navigation.subnavigation.share.title', profileOwner)}
            />
          </ThemeOverride>
        }
      >
        <ShareIcon />
      </IconButtonWithPopover>
    );
  }
);
ShareButton.displayName = 'ShareButton';

export default ShareButton;
